
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/seminar",
      function () {
        return require("private-next-pages/seminar/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/seminar"])
      });
    }
  